import { useTranslation } from 'react-i18next';
import { Anchor, Box, Button, Container, useMantineTheme } from '@mantine/core';
import StatusScreen from '@/components/common/StatusScreen';
import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_HREF } from '@/lib/contacts';
import { ROUTES } from '@/routes/paths';
import classes from '@/components/common/StatusScreen.module.css';

interface ErrorScreenProps {
  /**
   * Где показан экран. `root` — упал весь портал, шапки нет: показываем строку с логотипом и ведём на главную сайта.
   * `cabinet` — упала страница кабинета, шапка и меню остаются: ведём в кабинет.
   */
  readonly place?: 'root' | 'cabinet';
}

// Экран непредвиденной ошибки. Обновление может её повторить, поэтому есть выход и контакты поддержки.
// Ссылки обычные, не маршрутизатора: экран работает и тогда, когда сам маршрутизатор не отрисовался.
export default function ErrorScreen({ place = 'root' }: ErrorScreenProps) {
  const { t } = useTranslation();
  const { headerHeight } = useMantineTheme().other;
  const inCabinet = place === 'cabinet';

  const screen = (
    <StatusScreen
      title={t('errorScreen.title')}
      message={t(inCabinet ? 'errorScreen.messageCabinet' : 'errorScreen.message')}
      help={
        <>
          {t('errorScreen.support')}{' '}
          <Anchor href={ROUTES.SUPPORT_URL} target="_blank" rel="noopener noreferrer" c="brand.7" underline="always">
            {t('app.support')}
          </Anchor>
          {' · '}
          <Anchor href={`mailto:${CONTACT_EMAIL}`} c="brand.7" underline="always">
            {CONTACT_EMAIL}
          </Anchor>
          {' · '}
          <Anchor href={CONTACT_PHONE_HREF} c="brand.7" underline="always" style={{ whiteSpace: 'nowrap' }}>
            {CONTACT_PHONE}
          </Anchor>
        </>
      }
    >
      <Button onClick={() => window.location.reload()}>{t('errorScreen.reload')}</Button>
      <Button component="a" href={inCabinet ? ROUTES.APP : ROUTES.HOME} variant="default">
        {t(inCabinet ? 'notFound.toCabinet' : 'notFound.backHome')}
      </Button>
    </StatusScreen>
  );

  if (inCabinet) {
    return screen;
  }
  return (
    <>
      <Box component="header" h={headerHeight} className={classes.bar}>
        <Container size="lg" className={classes.barInner}>
          <a href={ROUTES.HOME} aria-label={t('app.name')} style={{ display: 'inline-flex' }}>
            <img src="/logo.svg" alt="" height={24} />
          </a>
        </Container>
      </Box>
      <main>{screen}</main>
    </>
  );
}
